/* Email-capture pop-up — offers a 5% discount code in exchange for an email.
   Submits natively to Shopify's customer (newsletter) form at /contact, which
   records the subscriber with email-marketing consent — that's what triggers the
   welcome automation that emails the code. The discount code works for anyone, so
   we always reveal it on submit, even if the capture call fails. URLs come from
   window.MDPOP (set by snippets/email-popup.liquid). */
(function () {
  "use strict";

  var CFG = window.MDPOP || {};
  var CODE = "READING5";
  var BOOKS_URL = CFG.booksUrl || "/collections/all";
  var PRIVACY_URL = CFG.privacyUrl || "/pages/privacy";
  var CONTACT_URL = CFG.contactUrl || "/contact";
  var DELAY_MS = 6000;            // show after this long on the page
  var SNOOZE_DISMISS_DAYS = 14;   // re-ask this many days after a dismiss
  var SNOOZE_DONE_DAYS = 180;     // leave converted visitors alone this long
  var KEY = "mdpop";              // localStorage: { until: <ms timestamp> }
  var SESSION_KEY = "mdpop-seen"; // sessionStorage: shown this session already

  // ---- suppression --------------------------------------------------------
  function snoozedUntil() {
    try {
      var raw = localStorage.getItem(KEY);
      if (!raw) return 0;
      return JSON.parse(raw).until || 0;
    } catch (e) { return 0; }
  }
  function snooze(days) {
    try {
      localStorage.setItem(KEY, JSON.stringify({ until: Date.now() + days * 864e5 }));
    } catch (e) {}
  }
  function shouldShow() {
    if (Date.now() < snoozedUntil()) return false;
    try { if (sessionStorage.getItem(SESSION_KEY)) return false; } catch (e) {}
    return true;
  }

  // ---- styles -------------------------------------------------------------
  var CSS = "" +
    ".mdpop-ov{position:fixed;inset:0;z-index:9999;display:flex;align-items:center;justify-content:center;" +
      "padding:20px;background:rgba(26,45,69,.55);opacity:0;transition:opacity .3s ease}" +
    ".mdpop-ov.open{opacity:1}" +
    ".mdpop{position:relative;width:100%;max-width:430px;background:var(--card,#fffdf6);color:var(--ink,#1a2d45);" +
      "border:3px solid var(--ink,#1a2d45);border-radius:22px;box-shadow:0 18px 50px rgba(26,45,69,.35);" +
      "padding:34px 30px 30px;transform:translateY(14px) scale(.98);transition:transform .3s ease;" +
      "max-height:calc(100dvh - 40px);overflow-y:auto;" +
      "font-family:'Nunito',sans-serif;text-align:center}" +
    ".mdpop-ov.open .mdpop{transform:none}" +
    ".mdpop-x{position:absolute;top:8px;right:10px;width:44px;height:44px;display:flex;align-items:center;justify-content:center;border:none;background:transparent;" +
      "font-size:26px;line-height:1;color:var(--soft,#8a7c61);cursor:pointer;border-radius:50%}" +
    ".mdpop-x:hover{background:var(--paper-deep,#f7ecd2);color:var(--ink,#1a2d45)}" +
    ".mdpop-bee{font-size:40px;display:block;margin:0 0 6px}" +
    ".mdpop h2{font-family:'Chewy',cursive;font-weight:400;font-size:clamp(26px,6vw,32px);line-height:1.1;margin:0 0 8px;color:var(--leaf-dark,#1a4d8a)}" +
    ".mdpop p{font-size:16px;line-height:1.5;margin:0 0 18px;color:var(--ink,#1a2d45)}" +
    ".mdpop .big{font-family:'Chewy',cursive;color:var(--ladybird,#e8721e)}" +
    ".mdpop input[type=email]{width:100%;font-family:'Nunito',sans-serif;font-size:16px;padding:13px 15px;" +
      "border:2px solid var(--lilac-border,#b89de0);border-radius:12px;background:#fff;color:var(--ink,#1a2d45);outline:none}" +
    ".mdpop input[type=email]:focus{border-color:var(--leaf,#2e72b8)}" +
    ".mdpop .hp{position:absolute;left:-9999px;width:1px;height:1px;overflow:hidden}" +
    ".mdpop-consent{display:flex;gap:9px;align-items:flex-start;text-align:left;margin:13px 2px 4px;font-size:13px;line-height:1.45;color:var(--soft,#8a7c61)}" +
    ".mdpop-consent input{margin-top:3px;flex:0 0 auto;width:16px;height:16px;accent-color:var(--leaf,#2e72b8)}" +
    ".mdpop-consent a{color:var(--leaf-dark,#1a4d8a)}" +
    ".mdpop-btn{width:100%;margin-top:16px;font-family:'Patrick Hand',cursive;font-size:21px;letter-spacing:.3px;" +
      "padding:13px 18px;border:2.5px solid var(--ink,#1a2d45);border-radius:14px;cursor:pointer;" +
      "background:var(--bee,#f4b942);color:var(--ink,#1a2d45);transition:transform .12s ease,background .15s ease}" +
    ".mdpop-btn:hover{background:var(--bee-deep,#e09c1a);transform:translateY(-1px)}" +
    ".mdpop-btn:disabled{opacity:.6;cursor:default;transform:none}" +
    ".mdpop-err{color:var(--ladybird,#e8721e);font-size:13.5px;margin:10px 0 0;min-height:1px}" +
    ".mdpop-fine{font-size:12px;color:var(--soft,#8a7c61);margin:12px 0 0}" +
    ".mdpop-code{font-family:'Chewy',cursive;font-size:30px;letter-spacing:2px;color:var(--leaf-dark,#1a4d8a);" +
      "background:var(--paper-deep,#f7ecd2);border:2px dashed var(--bee-deep,#e09c1a);border-radius:12px;" +
      "padding:14px 10px;margin:6px 0 4px;user-select:all}" +
    ".mdpop-copy{font-family:'Patrick Hand',cursive;font-size:16px;background:none;border:none;color:var(--leaf-dark,#1a4d8a);" +
      "text-decoration:underline;cursor:pointer;margin-bottom:14px}" +
    "@media (max-width:480px){.mdpop{padding:30px 22px 26px}}";

  // ---- markup -------------------------------------------------------------
  var FORM_HTML = "" +
    '<button class="mdpop-x" type="button" aria-label="No thanks, close">&times;</button>' +
    '<span class="mdpop-bee" aria-hidden="true">🐝</span>' +
    '<h2>Pssst — want <span class="big">5% off?</span></h2>' +
    '<p>Pop your email in and I\'ll send you a code for 5% off all books — signed copies included.</p>' +
    '<form class="mdpop-form" novalidate>' +
      '<input type="email" name="email" placeholder="you@email.com" autocomplete="email" required>' +
      '<input class="hp" type="text" name="company" tabindex="-1" autocomplete="off" aria-hidden="true">' +
      '<label class="mdpop-consent">' +
        '<input type="checkbox" name="consent" required>' +
        '<span>Yes, email me my discount code and the occasional update from Matt. ' +
        'I can unsubscribe anytime. See the <a href="' + PRIVACY_URL + '" target="_blank" rel="noopener">privacy policy</a>.</span>' +
      '</label>' +
      '<p class="mdpop-err" role="alert"></p>' +
      '<button class="mdpop-btn" type="submit">Send me the code</button>' +
    '</form>' +
    '<p class="mdpop-fine">No spam, ever. Just stories and the odd 5% off.</p>';

  function successHTML() {
    return "" +
      '<button class="mdpop-x" type="button" aria-label="Close">&times;</button>' +
      '<span class="mdpop-bee" aria-hidden="true">🎉</span>' +
      '<h2>You\'re in!</h2>' +
      '<p>Here\'s your code — use it at checkout for <strong>5% off</strong>. ' +
      'I\'ve emailed you a copy too.</p>' +
      '<div class="mdpop-code">' + CODE + '</div>' +
      '<button class="mdpop-copy" type="button">Tap to copy</button>' +
      '<a class="mdpop-btn" href="' + BOOKS_URL + '" style="display:block;text-decoration:none;box-sizing:border-box">Browse the books →</a>';
  }

  // ---- behaviour ----------------------------------------------------------
  var ov, card, shown = false;

  function build() {
    var style = document.createElement("style");
    style.textContent = CSS;
    document.head.appendChild(style);

    ov = document.createElement("div");
    ov.className = "mdpop-ov";
    ov.setAttribute("role", "dialog");
    ov.setAttribute("aria-modal", "true");
    ov.setAttribute("aria-label", "Get 5% off");
    card = document.createElement("div");
    card.className = "mdpop";
    card.innerHTML = FORM_HTML;
    ov.appendChild(card);
    document.body.appendChild(ov);

    ov.addEventListener("click", function (e) { if (e.target === ov) close(true); });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && ov.classList.contains("open")) close(true);
    });
    wireForm();
  }

  function open() {
    if (shown) return;
    shown = true;
    try { sessionStorage.setItem(SESSION_KEY, "1"); } catch (e) {}
    requestAnimationFrame(function () { ov.classList.add("open"); });
    var input = card.querySelector("input[type=email]");
    // trap focus inside the dialog (keyboard users can't tab behind it)
    setTimeout(function () {
      if (typeof trapFocus === "function") { trapFocus(card, input || card); }
      else if (input) { input.focus(); }
    }, 300);
  }

  function close(snoozeShort) {
    if (typeof removeTrapFocus === "function") { removeTrapFocus(); }
    ov.classList.remove("open");
    if (snoozeShort) snooze(SNOOZE_DISMISS_DAYS);
    setTimeout(function () { if (ov && ov.parentNode) ov.parentNode.removeChild(ov); }, 300);
  }

  function wireForm() {
    card.querySelector(".mdpop-x").addEventListener("click", function () { close(true); });
    var form = card.querySelector(".mdpop-form");
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var err = card.querySelector(".mdpop-err");
      var email = form.email.value.trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        err.textContent = "That email doesn't look quite right — mind checking it?";
        return;
      }
      if (!form.consent.checked) {
        err.textContent = "Please tick the box so I can email you the code.";
        return;
      }
      err.textContent = "";
      var btn = card.querySelector(".mdpop-btn");
      btn.disabled = true;
      btn.textContent = "Sending…";

      subscribe(email, form.company.value).then(function () {
        snooze(SNOOZE_DONE_DAYS);
        showSuccess();
      });
    });
  }

  // Native Shopify newsletter signup: posts to the customer form at /contact,
  // which records the email with marketing consent (fires the welcome automation).
  // Honeypot filled => silently skip the write but still reveal the code.
  function subscribe(email, honeypot) {
    if (honeypot) { return Promise.resolve(); }
    var fd = new FormData();
    fd.append("form_type", "customer");
    fd.append("utf8", "✓");
    fd.append("contact[email]", email);
    fd.append("contact[tags]", "newsletter, popup-reading5");
    return fetch(CONTACT_URL, {
      method: "POST",
      body: fd,
      headers: { "X-Requested-With": "XMLHttpRequest" }
    }).catch(function () { /* reveal the code regardless — it works for anyone */ });
  }

  function showSuccess() {
    card.innerHTML = successHTML();
    card.querySelector(".mdpop-x").addEventListener("click", function () { close(false); });
    var copy = card.querySelector(".mdpop-copy");
    copy.addEventListener("click", function () {
      var done = function () { copy.textContent = "Copied ✓"; };
      if (navigator.clipboard) navigator.clipboard.writeText(CODE).then(done, done);
      else done();
    });
  }

  // ---- triggers -----------------------------------------------------------
  function arm() {
    if (!shouldShow()) return;
    build();
    var timer = setTimeout(open, DELAY_MS);
    // Desktop exit-intent: bring it forward if they head for the tab bar.
    if (window.matchMedia && window.matchMedia("(pointer:fine)").matches) {
      document.addEventListener("mouseout", function onOut(e) {
        if (e.clientY <= 0 && !shown) {
          clearTimeout(timer);
          document.removeEventListener("mouseout", onOut);
          open();
        }
      });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", arm);
  } else {
    arm();
  }
})();
